module.exports = __webpack_public_path__ + "static/img/cnrhVkzwxjPwAaCfPbdc.65ace01d.png";